import React, { useState } from 'react';

const SummerContact = () => {

    const [status, setStatus] = useState('idle');
    const [statusMsg, setStatusMsg] = useState('');

    const handleFinalSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        try {
            const response = await fetch('/sendmail.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
            });

            const result = await response.json();

            if (result.status === 'success') {
            setStatus('success');
            setStatusMsg("Registration Successful! We'll call you shortly.");
            e.target.reset(); // Clear form
            } else {
            throw new Error("Server error");
            }
        } catch (error) {
            setStatus('error');
            setStatusMsg("Something went wrong. Please call 9700213084.");
        }
    };

    const handlePhoneInput = (e) => {
    // Use a Regular Expression to replace anything that is NOT a number with an empty string
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
    };

    return (
        <section className="contact-section" id="locations">
            <div className="container">
            <div className="contact-grid">
                
                {/* Left Side: Location Details */}
                <div className="location-info">
                <h2 className="section-heading-white">Visit Our Centers</h2>
                <p className="location-intro">Find the Narayana Summer Camp nearest to you in Tirupati.</p>
                
                <div className="center-cards-wrapper">
                    <div className="center-card">
                    <div className="center-icon">📍</div>
                    <div className="center-details">
                        <h4>Bhavani Nagar Center</h4>
                        <p>Main Branch, Tirupati, AP</p>
                        <a href="tel:9700213084" className="center-link">Call: 9700213084</a>
                    </div>
                    </div>

                    <div className="center-card">
                    <div className="center-icon">📍</div>
                    <div className="center-details">
                        <h4>MR Palli Center</h4>
                        <p>Branch Office, Tirupati, AP</p>
                        <a href="tel:9666560350" className="center-link">Call: 9666560350</a>
                    </div>
                    </div>
                </div>

                <div className="trust-footer">
                    <p>Trusted by 2,000+ parents every year across Tirupati.</p>
                </div>
                </div>

                {/* Right Side: Final Inline Form 2 */}
                <div className="final-form-wrapper">
                <div className="final-form-card">
                    <h3>Secure Your Spot</h3>
                    <p>Last few seats left for the April 24th Batch!</p>
                    {/* 3. Display Status Messages inside the card */}
                    {status === 'success' && <div className="status-msg success">{statusMsg}</div>}
                    {status === 'error' && <div className="status-msg error">{statusMsg}</div>}

                    {status !== 'success' && (
                        <form className="summer-final-form" onSubmit={handleFinalSubmit}>
                        {/* IMPORTANT: Name attributes updated to match PHP keys */}
                        <input 
                            type="text" 
                            name="student_name" 
                            placeholder="Student Name" 
                            required 
                            disabled={status === 'loading'}
                        />
                        <input 
                            type="tel" 
                            name="parent_phone" 
                            placeholder="Parent's Mobile Number" 
                            required 
                            maxLength="10"
                            onInput={handlePhoneInput}
                            disabled={status === 'loading'}
                        />
                        <select name="selected_program" required disabled={status === 'loading'}>
                            <option value="">Select Interested Track</option>
                            <option value="Advanced Foundation">Advanced Foundation</option>
                            <option value="Basic Foundation">Basic Foundation</option>
                            <option value="Intermediate Bridge">Intermediate IIT-Foundation</option>
                            <option value="10th Class Bridge">10th Class Bridge Course</option>
                            <option value="Skill Oriented">Skill Oriented Courses</option>
                        </select>
                        
                        <input type="hidden" name="source" value="bottom_page_form" />
                        
                        <button type="submit" className="btn-submit-final" disabled={status === 'loading'}>
                            {status === 'loading' ? 'Processing...' : 'Register for Summer Camp'}
                        </button>
                        </form>
                    )}
                </div>
                </div>

            </div>
            </div>
        </section>
    );
};

export default SummerContact;